import { render, staticRenderFns } from "./AreaData.vue?vue&type=template&id=88799d2e&scoped=true&"
import script from "./AreaData.vue?vue&type=script&lang=js&"
export * from "./AreaData.vue?vue&type=script&lang=js&"
import style0 from "./AreaData.vue?vue&type=style&index=0&id=88799d2e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88799d2e",
  null
  
)

export default component.exports